// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nDBl","left":"styles_left__378t_","desktopActions":"styles_desktopActions__39IJV","title":"styles_title__1zUbl"};